import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../store"
import BaseApi from "../../api/api"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { STATUS } from "../../utils/const"

type initialStateType = {
  lastStoksUpdated: string
  lastPricesUpdated: string
  status?: STATUS
  isCurrentDataUploaded: boolean
  errors?: { type: string; errors: any[] }[]

  ozon?: {
    lastStoksUpdated: string
    lastPricesUpdated: string
    status?: STATUS
    isCurrentDataUploaded: boolean
  }

  ya?: {
    lastStoksUpdated: string
    lastPricesUpdated: string
    status?: STATUS
    isCurrentDataUploaded: boolean
  }

  isDataFromKatrenUploaded: boolean
  isPromotionDataUploaded: boolean
}

const initialState: initialStateType = {
  lastStoksUpdated: "",
  lastPricesUpdated: "",
  isCurrentDataUploaded: false,
  isDataFromKatrenUploaded: false,
  isPromotionDataUploaded: false,
  ozon: {
    lastStoksUpdated: "",
    lastPricesUpdated: "",
    isCurrentDataUploaded: false,
  },
}

const updateStoksKatrenSlice = createSlice({
  name: "updateStoksKatren",
  initialState,
  reducers: {
    setUpdateStoksKatrenState: (
      state,
      action: PayloadAction<initialStateType>,
    ) => {
      state.lastStoksUpdated = action.payload.lastStoksUpdated
      state.lastPricesUpdated = action.payload.lastPricesUpdated
      state.status = action.payload.status
      state.isCurrentDataUploaded = action.payload.isCurrentDataUploaded
      state.isDataFromKatrenUploaded = action.payload.isDataFromKatrenUploaded
      state.isPromotionDataUploaded = action.payload.isPromotionDataUploaded
      state.errors = action.payload.errors
      state.ozon = action.payload.ozon
      state.ya = action.payload.ya
    },
  },
})

export const selectUpdateStoksKatrenStore = (state: RootState) =>
  state.updateStoksKatren

export default updateStoksKatrenSlice.reducer

export const { setUpdateStoksKatrenState } = updateStoksKatrenSlice.actions

export const deleteCurrentDataKatrenForOzon = createAsyncThunk(
  "deleteCurrentDataKatrenForOzon",
  (_, { dispatch }) => {
    return BaseApi.deleteCurrentDataKatrenForOzon()
      .then((response) => {
        console.log(response.data)
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const uploadCurrentDataKatrenForOzon = createAsyncThunk(
  "uploadCurrentDataKatrenForOzon",
  (file: File, { dispatch }) => {
    const formData = new FormData()
    formData.append("file", file)
    return BaseApi.uploadCurrentDataKatrenForOzon(formData)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const katrenUpdateStoksForOzon = createAsyncThunk(
  "katrenUpdateStoksForOzon",
  (
    props: {
      selectedStorageId: string
      updatePrices: boolean
      updateStocks: boolean
    },
    { dispatch },
  ) => {
    const { selectedStorageId, updatePrices, updateStocks } = props
    return BaseApi.katrenUpdateStoksForOzon(
      selectedStorageId,
      updatePrices,
      updateStocks,
    )
      .then((response) => {
        if (response.data) {
          response.data?.state &&
            dispatch(setUpdateStoksKatrenState(response.data.state))
          NotificationService.showNotification({
            message: response.data.message,
            level: (response.data.success && "success") || "error",
          })
        }
      })
      .catch((error) => {
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
      })
  },
)

export const uploadDataFromKatren = createAsyncThunk(
  "uploadDataFromKatren",
  (
    {
      data,
      fileName,
    }: {
      data: {
        name: string
        amount: number
        price: number
        priceInfo?:
          | {
              price: number
              storage?: string | undefined
            }[]
          | undefined
      }[]
      fileName?: string
    },
    { dispatch },
  ) => {
    return BaseApi.uploadDataFromKatren(data, fileName)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const deleteDataFromKatren = createAsyncThunk(
  "deleteDataFromKatren",
  (_, { dispatch }) => {
    return BaseApi.deleteDataFromKatren()
      .then((response) => {
        console.log(response.data)
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const updateKatrenStoksState = createAsyncThunk(
  "updateKatrenStoksState",
  (_, { dispatch }) => {
    return BaseApi.katrenUpdateStocksState()
      .then((response) => {
        if (response.data) {
          dispatch(setUpdateStoksKatrenState(response.data))
        }
      })
      .catch((error) => {
        console.error(error)
      })
  },
)

export const deleteCurrentDataKatrenForWB = createAsyncThunk(
  "deleteCurrentDataKatrenForWB",
  (_, { dispatch }) => {
    return BaseApi.deleteWBKatrenRecode()
      .then((response) => {
        console.log(response.data)
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const uploadCurrentDataKatrenForWB = createAsyncThunk(
  "uploadCurrentDataKatrenForWB",
  (file: File, { dispatch }) => {
    const formData = new FormData()
    formData.append("file", file)
    return BaseApi.uploadWBKatrenRecode(formData)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const katrenUpdateStoksForWB = createAsyncThunk(
  "katrenUpdateStoksForWB",
  (
    props: {
      selectedStorageId: string
      updatePrices: boolean
      updateStocks: boolean
      isReturnToPromo?: boolean
    },
    { dispatch },
  ) => {
    const { selectedStorageId, updatePrices, updateStocks, isReturnToPromo } =
      props
    return BaseApi.katrenUpdateStoks(
      selectedStorageId,
      updatePrices,
      updateStocks,
      isReturnToPromo,
    )
      .then((response) => {
        if (response.data) {
          response.data?.state &&
            dispatch(setUpdateStoksKatrenState(response.data.state))
          NotificationService.showNotification({
            message: response.data.message,
            level: (response.data.success && "success") || "error",
          })
        }
      })
      .catch((error) => {
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
      })
  },
)

export const deleteCurrentDataKatrenForYandex = createAsyncThunk(
  "deleteCurrentDataKatrenForYandex",
  (_, { dispatch }) => {
    return BaseApi.deleteCurrentDataKatrenForYandex()
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const uploadCurrentDataKatrenForYandex = createAsyncThunk(
  "uploadCurrentDataKatrenForYandex",
  (file: File, { dispatch }) => {
    const formData = new FormData()
    formData.append("file", file)
    return BaseApi.uploadCurrentDataKatrenForYandex(formData)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
        // Обработайте ошибку загрузки файла
      })
  },
)

export const katrenUpdateStoksForYandex = createAsyncThunk(
  "katrenUpdateStoksForYandex",
  (
    props: {
      selectedStorageId: string
      updatePrices: boolean
      updateStocks: boolean
    },
    { dispatch },
  ) => {
    const { selectedStorageId, updatePrices, updateStocks } = props
    return BaseApi.katrenUpdateStoksForYandex(
      selectedStorageId,
      updatePrices,
      updateStocks,
    )
      .then((response) => {
        if (response.data) {
          response.data?.state &&
            dispatch(setUpdateStoksKatrenState(response.data.state))
          NotificationService.showNotification({
            message: response.data.message,
            level: (response.data.success && "success") || "error",
          })
        }
      })
      .catch((error) => {
        error?.response?.data?.state &&
          dispatch(setUpdateStoksKatrenState(error.response.data.state))
      })
  },
)

export const deletePromoDataWB = createAsyncThunk(
  "deletePromoDataWB",
  (_, { dispatch }) => {
    return BaseApi.deletePromoDataWB()
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        NotificationService.showNotification({
          message: "Ошибка при удалении данных",
          level: "error",
          errorBody: error.response,
        })
      })
  },
)

export const savePromoDataWB = createAsyncThunk(
  "savePromoDataWB",
  (
    data: {
      planPrice: number
      nmId: number
    }[],
    { dispatch },
  ) => {
    return BaseApi.savePromoDataWB(data)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStoksKatrenState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        NotificationService.showNotification({
          message: "Ошибка при сохранении данных",
          level: "error",
          errorBody: error.response,
        })
      })
  },
)
